import script from "./SportHeroBannerItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./SportHeroBannerItem.vue?vue&type=script&setup=true&lang=ts"

import "./SportHeroBannerItem.vue?vue&type=style&index=0&id=5b944ab5&lang=scss"

const __exports__ = script;

export default __exports__